// extracted by mini-css-extract-plugin
export default {"limitInfoDiv":"style_limitInfoDiv__pqVXt","title":"style_title__+pEqX","closeBtn":"style_closeBtn__5jG4j","message":"style_message__s-4Hi"};